import type { ICarouselState } from '../models';

export type TCarouselState = ICarouselState & { clientWidth: number };

const getCurrentScrollPos = (cardWidths: number[], currentScroll: number, cardSpacing: number) => {
    return cardWidths.reduce((acc, cardWidth) => {
        const nextWidth = acc + cardWidth;

        if (nextWidth >= currentScroll) {
            return acc;
        }

        return nextWidth + cardSpacing;
    }, 0);
};

export const moveRight = ({
    cardSpacing,
    cardWidths,
    clientWidth,
    currentScroll,
    scrollWidth,
}: TCarouselState) => {
    const currentScrollPos = getCurrentScrollPos(cardWidths, currentScroll, cardSpacing);

    const nextScrollPos = currentScrollPos + clientWidth + cardSpacing;

    return nextScrollPos >= scrollWidth - clientWidth ? scrollWidth - clientWidth : nextScrollPos;
};

export const moveLeft = ({
    cardSpacing,
    cardWidths,
    clientWidth,
    currentScroll,
}: TCarouselState) => {
    const currentScrollPos = getCurrentScrollPos(cardWidths, currentScroll, cardSpacing);

    const nextScrollPos = currentScrollPos - clientWidth - cardSpacing;

    return nextScrollPos <= 0 ? 0 : nextScrollPos;
};
